import { getInitData } from './getInitData';

const APP_VERSION = '0.0.1';

export const checkTgApp = () => {
  // Инструмент для очистки локального хранилища пользователя
  /**
   * В localStorage храним условную версию приложения, и если она изменилась
   * полностью очищаем localStorage и обновляем страницу
   */
  const localVersion = localStorage.getItem('ver');

  if (localVersion && localVersion !== APP_VERSION) {
    localStorage.clear();
    document.location.reload();
  }
  localStorage.setItem('ver', APP_VERSION);
};

export const expandTgApp = async () => {
  const tg = window.Telegram?.WebApp;
  if (!tg) return;

  const isMobile = ['android', 'ios'].includes(tg.platform);
  const version = parseFloat(tg.version);

  tg.ready(); // Уведомляем Telegram, что приложение готово
  await tg.expand(); // Разворачиваем приложение на весь экран

  // Пробуем включить полноэкранный режим, если доступен
  if (version >= 8.0 && isMobile) {
    tg.requestFullscreen();
    document.body.classList.add('full-screen');

    if (tg.platform === 'ios') document.body.classList.add('ios');
    else document.body.classList.add('android');
  }
  if (version >= 6.1) tg.disableVerticalSwipes(); // Отключаем вертикальные свайпы, если нужно
};

// Костыль - обновляем вьюпорт
export const hackViewPort = (): Promise<null> => {
  const viewportMetaTag = document.querySelector('meta[name="viewport"]');

  const replaceInitialScale = (scale: number) => {
    if (!viewportMetaTag) return;

    viewportMetaTag.setAttribute(
      'content',
      (viewportMetaTag.getAttribute('content') ?? '').replace(/initial-scale=(.*),/, `initial-scale=${scale},`),
    );
  };

  return new Promise((resolve) => {
    if (viewportMetaTag === null) resolve(null);

    replaceInitialScale(0.99);

    setTimeout(() => {
      replaceInitialScale(1);
      resolve(null);
    }, 100);
  });
};

export const getTgUserData = () => {
  const Telegram = window.Telegram;

  if (!Telegram || !Telegram.WebApp || !Telegram.WebApp.initData) {
    // Скрипт телеграма грузится с async, поэтому WebApp может быть ещё не готов —
    // в этом случае берём initData из параметров запуска мини-аппы
    const initDataFromLaunch = getInitData();

    if (initDataFromLaunch) {
      return { initData: initDataFromLaunch };
    }

    if (import.meta.env.DEV) {
      const initData = import.meta.env.VITE_INIT_DATA;

      return { initData };
    }
    return undefined;
  }

  const webApp = Telegram.WebApp;
  const user = webApp.initDataUnsafe.user;

  return { initData: webApp.initData, user };
};

export const isTelegramWebApp = (): boolean => {
  if (import.meta.env.DEV && import.meta.env.VITE_INIT_DATA) return true;
  return !!getInitData() || Boolean(window.Telegram?.WebApp?.initData);
};

export const setBrowserPlatformClass = () => {
  if (isTelegramWebApp()) return;
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) document.body.classList.add('android-browser');
  else if (/iPhone|iPad|iPod/i.test(ua)) document.body.classList.add('ios-browser');
};
